import { existingHeaders } from "./utils";

const resendTokenAPI = "/customer/email/token";

export const resendVerifyTokenService = {
  resendVerificationToken,
};

function resendVerificationToken(email) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ email: email }),
  };
  return fetch(resendTokenAPI, requestOptions);
}
